import { Controller } from "@hotwired/stimulus"

// Flashes a routine step the user just saved, so the update reads as the
// answer to their save rather than the page catching up. When none of the
// saved steps are on screen (a step moved to the other half), the first one
// scrolls into view. A step put back with Undo (`enter`) grows into place
// first, so the steps below make room for it instead of jumping.
export default class extends Controller {
  static values = { enter: Boolean }

  connect() {
    if (document.documentElement.hasAttribute("data-turbo-preview")) return

    const reduceMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches
    if (this.enterValue && !reduceMotion) this.growIn()

    this.revealIfOffscreen(reduceMotion)
    this.element.animate(
      [
        { backgroundColor: "#fffbeb" },
        { backgroundColor: "#fffbeb", offset: 0.35 },
        { backgroundColor: "#ffffff" }
      ],
      { duration: 1800, easing: "ease-out" }
    )
  }

  // Animates the step's whole row (its swipe container), which holds the
  // space it takes in the section.
  growIn() {
    const row = this.element.closest("[data-delete-product-target='container']") || this.element
    const height = row.offsetHeight
    const overflow = row.style.overflow
    const restore = () => { row.style.overflow = overflow }

    row.style.overflow = "hidden"
    row.animate(
      [
        { height: "0px", opacity: 0 },
        { height: `${height}px`, opacity: 1 }
      ],
      { duration: 300, easing: "ease-out" }
    ).finished.then(restore, restore)
  }

  revealIfOffscreen(reduceMotion) {
    const highlighted = [ ...document.querySelectorAll(`[data-controller~="${this.identifier}"]`) ]
    if (highlighted[0] !== this.element || highlighted.some((element) => this.isOnScreen(element))) return

    this.element.scrollIntoView({ block: "center", behavior: reduceMotion ? "auto" : "smooth" })
  }

  isOnScreen(element) {
    const { top, bottom } = element.getBoundingClientRect()
    return bottom > 0 && top < window.innerHeight
  }
}
